import { IPrivacy } from "./IPrivacy"

const PrivacyLink = ({ onClick }: IPrivacy) => {
    return (
        <div className="text-center pt-5 pb-5">
            <span
                className="primaryColorLight-900  text-xs"

            >
                با ورود به این سامانه،
                <span
                    className="text-[#BBA57A] anjomanRegular  text-xs"
                    onClick={() => onClick()}
                >
                    {" "}
                    قوانین و مقررات کمان لند
                    {" "}
                </span>

                را قبول می‌کنم
            </span>
        </div>
    )
}

export default PrivacyLink